import { render, staticRenderFns } from "./HomeService.vue?vue&type=template&id=88a893b8"
import script from "./HomeService.vue?vue&type=script&lang=js"
export * from "./HomeService.vue?vue&type=script&lang=js"
import style0 from "./HomeService.vue?vue&type=style&index=0&id=88a893b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports